/**
 * DetailAppLogo component.
 */
import DeviceConfig from '@devices/config';
import FlavourConfig from '@shared/config/flavours';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled detail app logo.
 */
const DetailAppLogo = styled.img<React.CSSProperties>`
  filter: ${() =>
    !DeviceConfig.capabilities.disableAnimations
      ? `drop-shadow(${0 * Screen.widthRatio}px ${0 * Screen.widthRatio}px ${
          4 * Screen.widthRatio
        }px #000000);`
      : ''};
  height: ${54 * Screen.widthRatio}px;
`;

DetailAppLogo.defaultProps = {
  src: FlavourConfig.images.bwLogo,
};

export default withImage(DetailAppLogo);
